/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class Channel extends Route {
  @service declare appService: any;

  queryParams = {
    tab: { refreshModel: false },
    section: { refreshModel: true },
  };

  reactEnabled() {
    return this.appService.app.canAccessReactIntegrationPages;
  }
}

export default ReactRoute(Channel);
